// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DCbllgTVAoOPhD7vZfPA{z-index:11;background-color:#fff;padding:50px;border-radius:1rem;max-width:600px;max-height:80vh;overflow-y:auto}@media screen and (max-width: 1023px){.DCbllgTVAoOPhD7vZfPA{padding:20px 30px}}.S7SmQPypEOZ3tBxSXAoJ{margin:0;padding-left:20px}.S7SmQPypEOZ3tBxSXAoJ li{font-weight:bold}.Nq5uaC23bvoBrTpDaCJn{display:flex;flex-direction:column}.u_Ak5dK3LRUpddaLccYY{padding:8px !important;margin-bottom:5px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalContent": `DCbllgTVAoOPhD7vZfPA`,
	"schoolList": `S7SmQPypEOZ3tBxSXAoJ`,
	"buttonContainer": `Nq5uaC23bvoBrTpDaCJn`,
	"confirmationButton": `u_Ak5dK3LRUpddaLccYY`
};
module.exports = ___CSS_LOADER_EXPORT___;
